import api from "@/api/axios";

export async function getPackages() {
  const response = await api.get("/packages");
  return response.data;
}
